import gql from 'graphql-tag';

import mainDisplayObjectFragment from './mainDisplayObjectFragment';

export const searchResultFragment = gql`
  fragment searchResultFragment on SearchResult {
    dokkioClass
    textSnippet
    neuralSimilarity
    mainDisplayObject {
      ...mainDisplayObjectFragment
    }
  }
  ${mainDisplayObjectFragment}
`;
export default searchResultFragment;
